module.exports = __webpack_public_path__ + "static/media/tutorial-book-round-1-1-1.6cbffe10.png";